// src/utils/resumeConstants.js
//
// Constantes do módulo de currículos (Fase G.1).
// Reúne taxonomias e mapas de rótulo usados pelos componentes de currículo.

export const VISIBILITY_LABELS = {
  public: 'Público',
  private: 'Privado',
};

export const CATEGORY_LABELS = {
  moradia: 'Moradia',
  alimentacao: 'Alimentação',
  trocas: 'Trocas',
  transporte: 'Transporte',
  documentacao: 'Documentação',
  emprego: 'Emprego',
  comunicacao: 'Comunicação',
  treinamento: 'Treinamento',
  saude: 'Saúde',
  outros: 'Outros',
};

export const EDUCATION_LEVELS = {
  fundamental: 'Ensino Fundamental',
  medio: 'Ensino Médio',
  tecnico: 'Curso Técnico',
  superior: 'Ensino Superior',
  pos: 'Pós-graduação',
  mestrado: 'Mestrado',
  doutorado: 'Doutorado',
};

export const LANGUAGE_LEVELS = {
  basico: 'Básico',
  intermediario: 'Intermediário',
  avancado: 'Avançado',
  fluente: 'Fluente',
  nativo: 'Nativo',
};

export const AVAILABILITY_TYPES = {
  clt: 'CLT',
  pj: 'PJ',
  freelancer: 'Freelancer',
  estagio: 'Estágio',
  voluntariado: 'Voluntariado',
};

export const ALLOWED_ATTACHMENT_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

export const MAX_ATTACHMENT_SIZE_BYTES = 5 * 1024 * 1024; // 5 MB

export const BRAZILIAN_STATES = [
  'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO',
  'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI',
  'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO',
];

export const initialResume = {
  userId: '',
  visibility: 'private',
  fullName: '',
  email: '',
  phone: '',
  nationality: '',
  country: 'Brasil',
  state: '',
  city: '',
  headline: '',
  about: '',
  category: '',
  education: [],
  experience: [],
  languages: [],
  skills: [],
  availability: {
    types: [],
    immediate: false,
    remote: false,
  },
  attachmentUrl: '',
  attachmentName: '',
};
